export const platformSlugs = ['mobile', 'switch', 'xbox', 'playstation', 'pc'];
export const isPlatformSlug = (maybePlatformSlug) => {
    return platformSlugs.includes(maybePlatformSlug);
};
